export const DEBOUNCED_HANDLER_DELAY = 100;

export const DESKTOP_MAX_CONTENT_WIDTH = 1200;

export const LOCALE_CODE_REGEX = /^(?:\/\w+)?\/(\w+)\/(\w+)/;

export const BAZAAR_VOICE_URL = 'https://api.bazaarvoice.com/data/statistics.json';

export const REVIEW_SECTION_ANCHOR = '#pdp-reviews';
export const SDL_HEADER_SELECTOR = '.js-header-global .js-header';
export const SDL_HEADER_SELECTOR_APC = '.js-header-global .js-header-apc';
export const SDL_REDESIGN_HEADER_SELECTOR = '.se2--header-se .se2--header-se--common-part';

export const siteType = {
  B2B: 'b2b',
  B2C: 'b2c',
} as const;

export const b2cSiteTypeURLPrefix = 'home';

export const rangeBasePath = 'product-range';

export const COMMERCIAL_STATUS_MAX_LENGTH = 28;

export const TAB_BAR_HEIGHT = 48;

export const scrollBehavior = {
  SMOOTH: 'smooth',
  AUTO: 'auto',
} as const;

export const SLASH = '/';

export enum ECommercialStatus {
  COMMERCIALIZED = 'COMMERCIALIZED',
  LEGACY = 'LEGACY',
  PRECOMMERCIALIZED = 'PRECOMMERCIALIZED',
  END_OF_COMMERCIALIZATION_ANNOUNCED = 'END_OF_COMMERCIALIZATION_ANNOUNCED',
}

export enum EPromiseStatus {
  PENDING = 'pending',
  FULFILLED = 'fulfilled',
  REJECTED = 'rejected',
  SETTLED = 'settled',
}
export const sustainabilityGroupNameAtg = {
  groupExternalLabels: 'group_external_labels_atg',
  sustainabilityGroupDefault: 'sustainability_group_default_atg',
  groupResourcePerformance: 'group_resource_performance_atg',
  groupChemicalPerformance: 'group_chemical_performance_atg',
};

export const sustainabilityGroupNameSpryker = {
  groupExternalLabels: 'group_external_labels',
  sustainabilityGroupDefault: 'sustainability_group_default',
  groupResourcePerformance: 'group_resource_performance',
  groupChemicalPerformance: 'group_chemical_performance',
};

export enum Protocol {
  HTTP = 'http',
  HTTPS = 'https',
}

// ATG Substitution
export const SUBSTITUTION_PRODUCTS_ENDPOINT = '/product/ajax/model/com/schneider/rest/cached/GetSubstitutionsDetailsActor/substitutions';

export enum NUMERIC_SEPARATOR {
  COMMA = ',',
  DOT = '.',
}

export const enum FeatureStatus {
  ENABLED = 'enabled',
  DISABLED = 'disabled',
}

export const PES_USER = {
  TOKEN_KEY: 'pes_user_token_key',
} as const;

export enum ExtraBadgesCharId {
  ATS_MADE_IN_AMERICA = 'ATS_MADE_IN_AMERICA',
}

export enum CircularProductTypes {
  LINEAR = 'linear',
  REFURBISHED = 'refurbished',
  REPACKED = 'repacked',
  REMANUFACTURED = 'remanufactured',
}

export enum HMCPlatform {
  SE = 'SE',
  MySchneider = 'MySchneider',
}

export const CAASContentOverviewSlotName = 'caas-content-overview';

// Product Selector
export const SC = 'sc';
export const EZ = 'ez';
export const HPC = 'hpc';
export const CR = 'cr';
export const DISABLED = 'disabled';

export const MY_SCHNEIDER_CLICK_EVENT = 'pesLinkClick';

export const HMC_CLOSE_EVENT = 'closeHmcPopup';

export const enum PartType {
  CTO = 'cto',
  NON_CTO = 'nonCto',
}

export const enum CheckoutEventPayloadType {
  EASY = 'easy',
  SELECTOR_CONFIG = 'sc',
}

// Used for deciding which product-cart page to show. The one using ATG or the one using Spryker
export enum CartVersion {
  'v3' = 'v3',
  'v2' = 'v2',
}
